module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-empty-60469a3cc2bfd77e8846a9bf2a2d3c05.svg";